import { Empty } from 'antd';
import React, { useEffect, useState } from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { Link, useParams } from 'react-router-dom';
import { getAccess, log } from 'utils';
import { deleteProgramme, fetchProgramme } from 'state/actions/programme';
// import { regexInput } from 'utils/regex';
// import Table from 'components/Table';
import './Programmes.scss';
import _ from 'underscore';
import { EmptyIcon } from 'assets/icon/bigicon';
import { FilterIcon, LayerIcon } from 'assets/icon';
import ModalProgrammeCategoryForm from 'components/ModalProgrammeCategoryForm';
import {
  createProgrammeCategory,
  deleteProgrammeCategory,
  fetchProgrammeCategories,
  modifyProgrammeCategory,
  setProgrammeCategory,
} from 'state/actions/programmeCategories';
import ModalDelete from 'components/ModalDelete';
import Cards from 'design-components/Cards';
import CategoryDropdown from 'components/CategoryDropdown';
import { getRole } from 'utils/secrets';
import { fetchEditorData } from 'state/actions/editors';

const Programmes = ({ history }) => {
  const { siteId, siteName } = useParams();

  const {
    programmeList,
    programmeCategories,
    loading,
    userData,
    updated,
    category,
    categoryLoading,
    siteList,
  } = useSelector(
    (state) => ({
      programmeList: state.programme.list,
      programmeCategories: state.programmeCategories.list,
      error: state.programme.error,
      loading: state.programme.loading,
      deleted: state.programme.deleted,
      userData: state.auth.userData,
      updated: state.programme.updated,
      category: state.programmeCategories.programmeCategory,
      categoryLoading: state.programmeCategories.loading,
      programmeData: state.programme.programme,
      siteList: state.sites.list,
    }),
    shallowEqual
  );

  const site = siteList.find((s) => s._id === siteId);

  if (programmeList) {
    log(programmeList, '<<< infor list');
  }

  const [deleteModal, setDeleteModal] = useState({
    programme: null,
    isOpen: false,
  });

  const dispatch = useDispatch();


  const [search, setSearch] = useState();
  // const [isEditing, setIsEditing] = useState(false);
  // const [visible, setVisible] = useState(false);
  // const [searchError, setSearchError] = useState(null);
  const [selectedCategory, setSelectedCategory] = useState('all');
  const [tempSelectedCategory, setTempSelectedCategory] = useState(
    selectedCategory
  );
  const [playlistOpen, setPlaylistOpen] = useState(false);
  // const [minValue, setMinValue] = useState(0);
  // const [maxValue, setMaxValue] = useState(16);
  const [modalCategory, setModalCategory] = useState(false);
  const [modalDeleteCategory, setModalDeleteCategory] = useState({
    show: false,
    category: null,
  });
  const [selectedLinkFilter, setSelectedLinkFilter] = useState('all');
  const [tempSelectedLinkFilter, setTempSelectedLinkFilter] = useState(
    selectedLinkFilter
  );
  const [linkOpen, setLinkOpen] = useState(false);
  const linkFilters = [
    { _id: 'full', name: 'Linked to Shape' },
    { _id: 'partial', name: 'Partial Linked to Shape' },
    { _id: 'none', name: 'Unlinked to Shape' },
  ];

  const handleSetLinkFilter = () => {
    setSelectedLinkFilter(tempSelectedLinkFilter);
    setLinkOpen(false);
  };

  const [access, setAccess] = useState(null);
  const [role, setRole] = useState(null);

  useEffect(() => {
    fetchData();
  }, [dispatch]);

 const fetchData = async () => {
    try {
      const roleData = await getRole();
      setRole(roleData);
    } catch (error) {
      log('Error retrieving role:', error);
    }
  };


  const uid = userData.id;

  useEffect(() => {
    // hasShape is computed from the editor shapes at list-fetch time, so load
    // shapes first or every card ends up "none".
    if (site && site.editorSiteId) {
      dispatch(fetchEditorData({ siteId: site.editorSiteId })).then(() =>
        dispatch(fetchProgramme({ siteId }))
      );
    } else {
      dispatch(fetchProgramme({ siteId }));
    }
    dispatch(fetchProgrammeCategories({ siteId }));
    setSelectedCategory('all');
  }, [siteId]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    log(updated);
    if (updated && !loading) {
      dispatch(fetchProgramme({ siteId }));
    }
  }, [updated, loading]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (userData && userData.roleAccess) {
      setAccess(getAccess(userData, 'tenant', siteId));
    }
  }, [userData, siteId]);

  const onRemoveButtonClickHandler = (programme) => {
    setDeleteModal({
      programme,
      isOpen: true,
    });
  };

  const onCloseModalHandler = () => {
    setDeleteModal({ programme: null, isOpen: false });
  };

  const onDeleteProgrammeHandler = () => {

    dispatch(
      deleteProgramme({ id: deleteModal.programme, siteId }, () => {
        onCloseModalHandler();
      })
    );
  };

  // const onNewProgrammeHandler = () => {
  //   setProgramme(defaultProgramme);
  //   setIsEditing(false);
  //   setVisible(true);
  // };

  const handleSearch = (e) => {
    // setSearchError(null);
    // if (!regexInput(e.target.value) && e.target.value) {
    //   setSearchError('Search cannot using special character');
    // }
    setSearch(e.target.value);
  };

  const dataByCategory = programmeList.filter((programme) => {
    return selectedCategory !== 'all'
      ? programme.categoryId === selectedCategory
      : true;
  });

  const dataByLinkFilter = dataByCategory.filter((programme) => {
    return selectedLinkFilter !== 'all'
      ? programme.hasShape?.toString() === selectedLinkFilter
      : true;
  });

  const filteredData = search
    ? dataByLinkFilter.filter((el) => {
        const clonedElem = { ...el };
        return clonedElem.name.toLowerCase().includes(search.toLowerCase());
      })
    : dataByLinkFilter;

  // const confirmMessage = useFormatMessage('Programme.confirm');

  // const permDeleteMessage = useFormatMessage('Programme.permDelete');

  const getCategory = (categoryId) => {
    const findCategory = programmeCategories.find(
      (cat) => cat._id === categoryId
    );
    return findCategory?.name;
  };

  const handleSetPlaylist = () => {
    setSelectedCategory(tempSelectedCategory);
    setPlaylistOpen(false);
  };

  const handleEdit = (id) => {
    history.push(`/${siteId}/information/${siteName}/programme/${id}`);
  };

  const onSubmitCategory = () => {
    const action = category._id
      ? modifyProgrammeCategory
      : createProgrammeCategory;

    dispatch(
      action({ uid, ...category, siteId, id: category._id }, () =>
        setModalCategory(false)
      )
    );
  };

  const handleSetCategory = (data) => {
    dispatch(setProgrammeCategory(data));
  };

  const handleEditCategory = (category) => {
    // setIsEditing(true);
    dispatch(setProgrammeCategory(category));
    setModalCategory(true);
  };

  const handleDeleteCategory = (category) => {
    setModalDeleteCategory({
      show: true,
      category,
    });
  };

  const onDeleteCategory = () => {
    dispatch(
      deleteProgrammeCategory(modalDeleteCategory.category._id, () =>
        onCloseModalCategoryHandler()
      )
    );
  };

  const onCloseModalCategoryHandler = () => {
    setModalDeleteCategory({
      show: false,
      category: null,
    });
  };

  const handleNew = () => {
    dispatch(
      setProgrammeCategory(
        {
          _id: '',
          name: '',
          description: '',
        },
        () => setModalCategory(true)
      )
    );
  };

  return (
    <div className="media-library">
      <ModalDelete
        isVisible={modalDeleteCategory.show}
        onOk={onDeleteCategory}
        onCancel={onCloseModalCategoryHandler}
        title="Delete Category"
        subtitle={
          modalDeleteCategory.category ? modalDeleteCategory.category.name : ''
        }
        loading={categoryLoading}
      />

      <ModalDelete
        isVisible={deleteModal.isOpen}
        onOk={onDeleteProgrammeHandler}
        onCancel={onCloseModalHandler}
        title="Delete Programme"
        subtitle={deleteModal.programme ? deleteModal.programme.name : ''}
        loading={loading}
      />

      <ModalProgrammeCategoryForm
        visible={modalCategory}
        onCancel={() => {
          setModalCategory(false);
        }}
        onCreate={onSubmitCategory}
        category={category}
        setCategory={handleSetCategory}
        isEditing={category._id ? true : false}
      />

      <div className="media-header">
        <div className="media-header-left">
          <div className="searchbar-wrapper">
            <div className="searchbar">
              <i className="feather-search" />
              <input
                placeholder="Search"
                className="search-input"
                // value={search}
                onChange={handleSearch}
              />
            </div>
          </div>
          <div
            className="playlist-wrapper"
            onClick={() => setPlaylistOpen(!playlistOpen)}
          >
            <div className="playlist-selection">
              <FilterIcon />
              <span>
                {selectedCategory === 'all'
                  ? 'Show All'
                  : getCategory(selectedCategory)}
              </span>
            </div>
            <i
              className={`feather-chevron-down ${
                playlistOpen ? 'playlist-open' : 'playlist-closed'
              }`}
            />

            <CategoryDropdown
              categories={programmeCategories}
              setTempSelectedCategory={(id) => setTempSelectedCategory(id)}
              handleEditCategory={(cat) => handleEditCategory(cat)}
              handleDeleteCategory={(cat) => handleDeleteCategory(cat)}
              modalOpen={playlistOpen}
              handleSetPlaylist={handleSetPlaylist}
              tempSelectedCategory={tempSelectedCategory}
              handleNew={handleNew}
              filter={true}
            />
            {/* <div
              className={`playlist-dropdown ${
                playlistOpen
                  ? 'playlist-dropdown-open'
                  : 'playlist-dropdown-closed'
              }`}
              onClick={(e) => e.stopPropagation()}
            >
              <ul>
                <li className="header" onClick={handleNew}>
                  <i className="feather-plus" />
                  Add New Category
                </li>
                <li>
                  <div
                    className={`radio ${
                      tempSelectedCategory === 'all' ? 'active' : ''
                    }`}
                    onClick={() => setTempSelectedCategory('all')}
                  >
                    {tempSelectedCategory === 'all' && (
                      <div className="radio-checked" />
                    )}
                  </div>
                  Show All
                </li>

                {programmeCategories.map((cat) => {
                  return (
                    <li key={cat._id}>
                      <div className="playlist-filter">
                        <div className="playlist-filter-radio">
                          <div
                            className={`radio ${
                              tempSelectedCategory === cat._id ? 'active' : ''
                            }`}
                            onClick={() => setTempSelectedCategory(cat._id)}
                          >
                            {tempSelectedCategory === cat._id && (
                              <div className="radio-checked" />
                            )}
                          </div>
                          {cat.name}
                        </div>
                        <Tooltip title="Options">
                          <Dropdown
                            trigger="click"
                            overlay={
                              <Menu>
                                <Menu.Item
                                  key="edit"
                                  onClick={() => handleEditCategory(cat)}
                                >
                                  <i className="feather-edit mr-2" />
                                  Edit
                                </Menu.Item>
                                <Menu.Divider />
                                <Menu.Item
                                  key="delete"
                                  onClick={() => handleDeleteCategory(cat)}
                                >
                                  <i className="feather-trash-2 mr-2" />
                                  Delete
                                </Menu.Item>
                              </Menu>
                            }
                          >
                            <button>
                              <i className="feather-more-horizontal" />
                            </button>
                          </Dropdown>
                        </Tooltip>
                      </div>
                    </li>
                  );
                })}
                <li className="playlist-button" onClick={handleSetPlaylist}>
                  Set Category
                </li>
              </ul>
            </div> */}
          </div>

          {role === 'superadmin' && site && site.editorSiteId && (
            <div
              className="playlist-wrapper"
              onClick={() => setLinkOpen(!linkOpen)}
            >
              <div className="playlist-selection">
                <LayerIcon />
                <span>
                  {selectedLinkFilter === 'all'
                    ? 'Link Shape Filter'
                    : linkFilters.find(
                        (link) => link._id === selectedLinkFilter
                      )?.name}
                </span>
              </div>
              <i
                className={`feather-chevron-down ${
                  linkOpen ? 'playlist-open' : 'playlist-closed'
                }`}
              />

              <CategoryDropdown
                categories={linkFilters}
                setTempSelectedCategory={(id) => setTempSelectedLinkFilter(id)}
                modalOpen={linkOpen}
                handleSetPlaylist={handleSetLinkFilter}
                tempSelectedCategory={tempSelectedLinkFilter}
                filter={true}
                title={'Link Filter'}
              />
            </div>
          )}
        </div>
        <div className="actions__wrapper">
          {role !== 'superadmin' ? (
            access &&
            access.create && (
              <Link
                to={`/${siteId}/information/${siteName}/programme/new`}
                className="btn-primary"
              >
                <i className="feather-plus mr-2" />
                New Programme
              </Link>
            )
          ) : (
            <Link
              to={`/${siteId}/information/${siteName}/programme/new`}
              className="btn-primary"
            >
              <i className="feather-plus mr-2" />
              New Programme
            </Link>
          )}
        </div>
      </div>

      <div className="media-content-wrapper">
        <div className="media-content">
          <div className="media-list-content">
            {programmeList.length > 0 && filteredData.length > 0 ? (
              _.chunk(filteredData, 3).map((chunk, index) => {
                return (
                  <div className="media-list-chunk" key={index}>
                    {chunk.map((programme) => {
                      return (
                        <div
                          key={programme._id}
                          data-id={programme._id}
                          className="media-list"
                        >
                          <Cards
                            data={programme}
                            type="information"
                            isShowMedia={true}
                            editAction={() => handleEdit(programme._id)}
                            deleteAction={() =>
                              onRemoveButtonClickHandler(programme._id)
                            }
                          />
                        </div>
                      );
                    })}
                    {chunk.length < 2 && <div className="media-list-empty" />}
                    {chunk.length < 3 && <div className="media-list-empty" />}
                  </div>
                );
              })
            ) : (
              <div className="media-empty">
                <Empty image={EmptyIcon} description="No Programme" />
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Programmes;
